import type { RouteRecordRaw } from 'vue-router'

import { registerCreativeAiMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const CREATIVE_AI_ROUTE = { name: 'CreativeAi' } as const
export const CREATIVE_AI_DETAIL_ROUTE = { name: 'CreativeAiDetail' } as const

const creativeAiLandingRoute: RouteRecordRaw = {
  path: 'creative-ai',
  name: CREATIVE_AI_ROUTE.name,
  component: () => import('./components/pages/CreativeAiLandingPage.vue'),
  meta: {
    requiresAuth: true,
    permission: 'flag:Creative-AI',
    navKey: 'creativeAi',
    titleKey: 'creativeAi.page.title',
    contentInset: 'none',
  },
  beforeEnter: () => registerCreativeAiMessages(useLocaleStore().locale),
}

const creativeAiDetailRoute: RouteRecordRaw = {
  path: 'creative-ai/:analysisId/:tab?',
  name: CREATIVE_AI_DETAIL_ROUTE.name,
  component: () => import('./components/pages/CreativeAiDetailPage.vue'),
  meta: {
    requiresAuth: true,
    permission: 'flag:Creative-AI',
    titleKey: 'creativeAi.page.detailTitle',
    contentInset: 'none',
  },
  beforeEnter: () => registerCreativeAiMessages(useLocaleStore().locale),
}

export const creativeAiRoutes: RouteRecordRaw[] = [creativeAiLandingRoute, creativeAiDetailRoute]
